export default __webpack_public_path__ + "5f9eca6040fe4096654db00f8db4b45c.woff";